import React from "react";

import calendarIcon from "url:shared-assets/icons/calendar.svg";
import clockIcon from "url:shared-assets/icons/gray/clock.svg";
import closeIcon from "url:shared-assets/icons/black/close.svg";
import informationIcon from "url:shared-assets/icons/black/information-circle.svg";
import {
  dateFormatDate,
  dateFormatHourMinute,
} from "../../../../helpers/dateFunctions";

interface BannerProps {
  selectedDate: Date;
  coachName?: string;
  title: string;
  close: Function;
}

const Banner: React.FC<BannerProps> = ({
  selectedDate,
  coachName,
  title,
  close,
}) => {
  return (
    <div
      className={`flex flex-col gap-4 bg-gray-200 text-indigo-1000 rounded-md border border-transparent p-4`}
    >
      {/* HEADER */}
      <div className="flex flex-row justify-between gap-2 align-middle items-center">
        <img src={informationIcon} alt="calendar icon" className="w-6 h-6" />
        <p className="z-title2 grow">{title}</p>
        <img
          src={closeIcon}
          alt="calendar icon"
          className="w-6 h-6 cursor-pointer"
          onClick={() => close()}
        />
      </div>
      {/* BODY */}
      <div className="flex flex-row justify-between gap-2 items-center">
        <p className="z-title3 grow">{coachName}</p>

        <div className="flex flex-row gap-1 items-center">
          <img src={calendarIcon} alt="calendar icon" className="w-6 h-6" />
          <p className="z-title3 text-center">
            {dateFormatDate(selectedDate, false, "sv")}
          </p>
        </div>
        <div className="flex flex-row gap-1 items-center">
          <img src={clockIcon} alt="calendar icon" className="w-6 h-6" />
          <p className="z-title3 text-center">
            {dateFormatHourMinute(selectedDate)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
